var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixaFrase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.865C5.65202 10.9527 5.82446 10.9989 6 10.9989C6.17554 10.9989 6.34798 10.9527 6.5 10.865L10 8.86495C10.1519 8.77727 10.278 8.65119 10.3658 8.49937C10.4535 8.34755 10.4998 8.17531 10.5 7.99995V3.99995C10.4998 3.82459 10.4535 3.65236 10.3658 3.50053C10.278 3.34871 10.1519 3.22263 10 3.13495L6.5 1.13495C6.34798 1.04718 6.17554 1.00098 6 1.00098C5.82446 1.00098 5.65202 1.04718 5.5 1.13495L2 3.13495C1.84813 3.22263 1.72199 3.34871 1.63423 3.50053C1.54647 3.65236 1.50018 3.82459 1.5 3.99995V7.99995C1.50018 8.17531 1.54647 8.34755 1.63423 8.49937C1.72199 8.65119 1.84813 8.77727 2 8.86495L5.5 10.865Z",
    stroke: "#2544B1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11V6",
    stroke: "#2544B1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64453 3.5L5.99953 6L10.3545 3.5",
    stroke: "#2544B1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.13477L8.25 4.70977",
    stroke: "#2544B1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixaFrase);
export default __webpack_public_path__ + "static/media/icone-caixa-frase.6481ceaa112cf6d6026a31c42f5e0fc7.svg";
export { ForwardRef as ReactComponent };